<template>
  <div class="@container">
    <div
      class="relative flex snap-x snap-proximity gap-12 gap-y-8 overflow-x-auto @lg:grid @lg:grid-cols-2 @lg:overflow-x-visible"
    >
      <section
        v-for="testimonial in list"
        :key="testimonial.id!"
        class="shrink-0 basis-[350px] snap-start break-inside-avoid text-sm"
      >
        <header class="flex items-center gap-2">
          <app-user-avatar
            :avatar-url="testimonial.author_avatar_url"
            class="!rounded-none"
            :name="testimonial.author_full_name"
            :size="45"
            :style="{
              clipPath: 'inset(0 round 50% 5% 50% 50%)',
            }"
          />
          <p>
            <strong>{{ testimonial.author_full_name }}</strong
            ><br />
            {{ testimonial.author_job_description }}
          </p>
        </header>

        <p
          class="mt-2 text-subtle before:mr-1 before:content-['“'] after:ml-1 after:content-['”']"
        >
          {{ testimonial.content }}
        </p>
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  list: DatabaseCompositeType<"teacher_testimonial">[];
}>();
</script>
